import { render, staticRenderFns } from "./customerlist2.vue?vue&type=template&id=e9316160&"
import script from "./customerlist2.vue?vue&type=script&lang=js&"
export * from "./customerlist2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports